import * as React from "react"

const SvgOnePerson = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 12.143q-1.65 0-2.825-1.175T8 8.143c0-1.65.392-2.043 1.175-2.825Q10.35 4.143 12 4.143c1.65 0 2.042.391 2.825 1.175Q16 6.492 16 8.143c0 1.651-.392 2.041-1.175 2.825Q13.65 12.143 12 12.143m-8 6v-.8q0-.85.438-1.563A2.9 2.9 0 0 1 5.6 14.693a14.8 14.8 0 0 1 3.15-1.163 13.8 13.8 0 0 1 3.25-.387q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.163 1.087.437.713.437 1.563v.8q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588H6q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 18.143m2 0h12v-.8a.97.97 0 0 0-.5-.85 13 13 0 0 0-2.725-1.013 11.6 11.6 0 0 0-5.55 0A13 13 0 0 0 6.5 16.493a.97.97 0 0 0-.5.85zm6-8q.825 0 1.412-.588Q14 8.968 14 8.143t-.588-1.413A1.93 1.93 0 0 0 12 6.143q-.825 0-1.412.587A1.93 1.93 0 0 0 10 8.143q0 .825.588 1.412.587.588 1.412.588" />
  </svg>
)
export default SvgOnePerson
